import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const DBSyncIcon = forwardRef<SVGSVGElement, IconProps>(function DBSyncIcon(
  { color = '', height = 18, width = 18, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <ellipse cx="6.66634" cy="3.33203" rx="5.33333" ry="2" stroke={color || 'currentColor'} strokeWidth="1.2" />
      <path
        d="M3.33301 7.22656C3.73406 7.34712 4.18256 7.4464 4.66634 7.51984"
        stroke={color || 'currentColor'}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M3.33301 11.8945C3.73406 12.0151 4.18256 12.1144 4.66634 12.1878"
        stroke={color || 'currentColor'}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M7.99935 10.3318L8.75686 11.3087C9.13804 9.88646 10.6003 9.04245 12.0228 9.42353C12.751 9.61861 13.3277 10.0969 13.666 10.7081M14.666 13.6643L13.9085 12.6887C13.5273 14.1109 12.0651 14.9549 10.6425 14.5739C9.93118 14.3833 9.36448 13.9226 9.02325 13.3317"
        stroke={color || 'currentColor'}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9997 3.33203V7.3375M1.33301 3.33203V12.6781C1.33301 13.6994 3.3688 14.5422 5.99967 14.6654"
        stroke={color || 'currentColor'}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33301 8C1.33301 9.02786 3.3688 9.87602 5.99967 10"
        stroke={color || 'currentColor'}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </SvgStyled>
  );
});
